import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { DBProject } from "@/lib/db-types";

/**
 * Fetch ALL projects (handles Supabase 1000-row default limit via pagination).
 */
async function fetchAllProjects(): Promise<DBProject[]> {
  const all: DBProject[] = [];
  const PAGE = 1000;
  let from = 0;

  while (true) {
    const { data, error } = await supabase
      .from("projects")
      .select("*")
      .is("deleted_at", null)
      .order("project_code", { ascending: false })
      .range(from, from + PAGE - 1);

    if (error) throw error;
    if (!data || data.length === 0) break;
    all.push(...(data as DBProject[]));
    if (data.length < PAGE) break;
    from += PAGE;
  }

  return all;
}

export function useProjects() {
  return useQuery({
    queryKey: ["projects"],
    queryFn: fetchAllProjects,
  });
}
